import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DataService } from 'src/shared/data/data.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {
    isLoading: boolean = false;

    constructor(
         private fb: FormBuilder,
         public data: DataService,
         private http: HttpClient,
         private meta: Meta,
         private titleService: Title
) {}

   ngOnInit(): void {
    this.contactForm = this.fb.group({
      lead_name: ['', Validators.required],
      contact_phone: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$'),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]],
      contact_email: ['', [
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')
      ]],
      customer_type: ['', Validators.required],
      delivery_location: ['', Validators.required],
      scope_of_project: [''],
      created_by: ['1'],
      source: ['10']
    });
 
    this.titleService.setTitle(
        'Contact Us | Sangeetha Toys'
    );

    this.meta.updateTag({
        name: 'description',
        content: 'Get in touch with Sangeetha Toys for product inquiries, orders, customer support, and toy recommendations. We are here to help you find the perfect toys, games, and gifts for every child.'
    });
  }
        
              public contactForm!: FormGroup;
              url:string='';
    

    
projectsContent = [
        {
            subTitle: "Contact Us",
            title: "Contact Us ",
            paragraph: "Our friendly toy specialists are ready to bring smiles to every child with a wide collection of fun, educational, and interactive toys. Explore exciting games, creative activities, and favorite characters designed to spark imagination and joyful play."
        }
    ];

submitContactForm() {

  this.isLoading = true;

  if (this.contactForm.invalid) {

    this.contactForm.markAllAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please fill all required fields correctly.'
    });

    this.isLoading = false;

    return;
  }

  this.http.post<any>(
    this.data.base_url +
    'save_contact_enquiry/',
    this.contactForm.value
  ).subscribe({

    next: (res) => {

      if (res.status === 1) {

        Swal.fire({
          icon: 'success',
          title: 'Thank You!',
          text:
            'Your enquiry has been submitted successfully.',
          confirmButtonColor: '#7c3aed'
        });

        this.contactForm.reset();

      } else {

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: res.message
        });

      }

    },

    error: (err) => {

      console.error(err);

      Swal.fire({
        icon: 'error',
        title: 'Server Error',
        text:
          'Something went wrong. Please try again later.'
      });

    },

    complete: () => {

      this.isLoading = false;

    }

  });

}
allowOnlyNumbers(event: KeyboardEvent) {

  const charCode = event.which
    ? event.which
    : event.keyCode;

  if (
    charCode > 31 &&
    (charCode < 48 || charCode > 57)
  ) {
    event.preventDefault();
  }

}
}
